import { collectMenuIds } from "./menuFilter";


export function buildCategoryUrl(item, level) {

    /*
    Level 1
    Example:
    c=14
    */
    if (level === 1) {
        // return `/products?c=${item.url}`;
        return `${item.url}`;
    }


    /*
    Level 2 and 3
    Example:
    g=165,206,207
    */
    const ids = collectMenuIds(item);


    return `/products?g=${ids.join(",")}`;
}